import gql from 'graphql-tag';

export default gql`
  mutation ($input: updateHubsCollegeLogoInput!) {
    updateHubsCollegeLogo(input: $input) {
      clientMutationId
      viewer {
        id
        heInstitution
        hubsCollegeLogo {
          college_logo {
            logoDisplayUrl
            logoUri
          }
        }
      }
    }
  }
`;
